import "./readable-stream-compat";
import workerUrl from "./pdf-worker.ts?worker&url";

export type PdfJsRuntime = typeof import("pdfjs-dist/legacy/build/pdf.mjs");

let runtimePromise: Promise<PdfJsRuntime> | null = null;

/**
 * Configures the one PDF.js worker entry bundled by Vite. The runtime import is
 * deliberately lazy: pure coordinate/text modules remain usable in SSR and
 * unit-test environments that do not provide DOMMatrix or canvas globals.
 */
export async function configurePdfRuntime(): Promise<PdfJsRuntime> {
  runtimePromise ??= import("pdfjs-dist/legacy/build/pdf.mjs").then((pdfjs) => {
    pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
    return pdfjs;
  });
  return runtimePromise;
}

export function getPdfRuntime(): Promise<PdfJsRuntime> {
  return configurePdfRuntime();
}

export async function getPdfJsExtractorVersion(): Promise<string> {
  const runtime = await getPdfRuntime();
  return `pdfjs-${runtime.version}`;
}
